<style lang="scss"></style>

<!-- eslint-disable -->
<template>
  <div class="print-queue-history">
    <h4 class="mb-2">Print Queue History</h4>
    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          hover
          :items="results"
          :fields="headers"
          :responsive="true"
          :sticky-header="'500px'"
        >
          <template #cell(prisoner_number)="data">
            {{data.item.prisoner_number || '-'}}
          </template>

          <template #cell(created_at)="data">
            {{data.item.created_at | formatDateTime}}
          </template>
          <template #cell(actions)="data">
            <b-btn class="full-width text-right" @click="openFile(data.item.file_url)" variant="link">View</b-btn>
          </template>
        </b-table>
        <b-row class="p-1">
          <p v-if="results.length === 0" class="col-6 ml-2 my-1">No records</p>
        </b-row>
      </section>
    </b-card>
  </div>
</template>
<!-- eslint-enable -->

<script>
  import { mapState } from 'vuex';
  import HelperService from '@/services/HelperService'
  import PrintQueueService from '@/services/PrintQueueService';

  export default {
    components: {},
    props: {},
    data() {
      return {
        helperService: new HelperService(),
        loading: true,
        headers: [
          { label: 'Date', key: 'created_at' },
          { label: '', key: 'actions' },
        ],
        results: [],
      };
    },
    computed: {
      ...mapState({
        printOnSite: state => state.auth.user.prison.purple_post_print_on_site,
        filters: state => state.postCard.filters,
      }),
    },
    mounted() {
      this.getPrintHistory();
    },
    methods: {
      getPrintHistory() {
        PrintQueueService.getPrintQueue().then(res => {
          this.results = res.data;
        }).catch(err => {
          console.log('Error getting print queue ', err);
          this.$toast.error('Could not get print queue history, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.loading = false;
        });
      },
      openFile(url) {
        window.open(url);
      },
    },
  };
</script>
